// Ürün Markaları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.brands';

export const inventoryBrandsGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  // Gerçek ekranda form solda, marka listesi sağda
  mirror: true,
  title: t(`${G}.title`, 'Ürün markaları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede ürün markalarını ekleyebilir, düzenleyebilir ve silebilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    form: t(`${G}.regions.form`, 'Marka formu'),
    list: t(`${G}.regions.list`, 'Mevcut markalar'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Yeni marka ekleyin'),
      text: t(`${G}.s1.text`, 'Listeden bir marka seçili değilken form "Yeni Marka Ekle" olarak açılır. Marka adını yazın; isterseniz açıklama ve web sitesi bilgisini de girin, sonra "Yeni Marka Ekle"ye basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Marka adı zorunludur; boşken kaydet düğmesi pasif kalır.'),
        t(`${G}.s1.tip2`, 'Şube alanı isteğe bağlıdır. Şube müdürüyseniz şube kendi şubeniz olarak sabittir.'),
        t(`${G}.s1.tip3`, 'Web sitesini https:// ile başlayan tam adres olarak yazın.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Markalar listesini inceleyin'),
      text: t(`${G}.s2.text`, '"Mevcut Markalar" bölümünde tanımlı tüm markalar ad, açıklama ve web sitesiyle listelenir; üstte toplam marka sayısı görünür. Web sitesi bağlantısına tıklayınca site yeni sekmede açılır.'),
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Düzenlemek için markayı seçin'),
      text: t(`${G}.s3.text`, 'Listeden bir markaya tıkladığınızda soldaki form o markanın bilgileriyle otomatik dolar ve başlık "Markayı Düzenle" olur. Seçili satır vurgulu görünür.'),
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Değişikliği kaydedin'),
      text: t(`${G}.s4.text`, 'Bilgileri değiştirip "Markayı Güncelle"ye basın. Düzenlemeden vazgeçmek için "İptal"e basın; form boşalır ve yeni marka ekleme moduna döner.'),
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Marka silme'),
      text: t(`${G}.s5.text`, 'Satırdaki kırmızı çöp kutusu simgesi (mobilde "Sil" düğmesi) onay penceresini açar. "Evet, Sil" ile marka silinir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Silme işlemi kalıcıdır, geri alınamaz. Silmeden önce marka bilgilerini kontrol edin.'),
      ],
    },
  ],
});
